export const modalTypes = {
  createShutdown: 'createShutdown',
  changeShutdownDesc: 'changeShutdownDesc',
  changeShutdownAlisaText: 'changeShutdownAlisaText',
  changeShutdownAddresses: 'changeShutdownAddresses',
  changeShutdownPlanEndDate: 'changeShutdownPlanEndDate',
  changeShutdownEndDate: 'changeShutdownEndDate',
  changeShutdownType: 'changeShutdownType',
  changeShutdownReason: 'changeShutdownReason',
  changeShutdownNotifyTo: 'changeShutdownNotifyTo',
  addShutdownInitiators: 'addShutdownInitiators',
  addShutdownResponsible: 'addShutdownResponsible',
  shutdownHistory: 'shutdownHistory',
};
